export default __webpack_public_path__ + "static/media/Logo.2662431a.svg";